import { graphql } from "../gql";

export const getAskAutodorQueueQueryDoc = graphql(`
  query getAskAutodorQueue($id: ID!) {
    askAutodorQueue(id: $id) {
      ...AskAutodorQueueFragment
      summary {
        ...AskAutodorQueueSummaryFragment
      }
    }
  }
`);
